import type { Prettify } from '@mnd-frontend/ts';
import { useTranslation } from 'react-i18next';
import { STEP, type StepCompleteMap, type StepIntroMap, type StepRestMap } from './types';

export type StepsMapType = Prettify<StepIntroMap & StepCompleteMap & StepRestMap>;

export const useOnboardingLocaleText = (): StepsMapType => {
  const { t } = useTranslation();

  return {
    [STEP.INTRO]: {
      subTitle: t('onboarding_trial_title_step1'),
    },
    [STEP.BRAND]: {
      subTitle: t('onboarding_trial_title_step2'),
      loader: {
        headline: t('onboarding_trial_loading_step2'),
        note1: t('onboarding_trial_loading_step2_note1'),
        note2: t('onboarding_trial_loading_step2_note2'),
      },
      disclaimer: t('onboarding_trial_disclaimer_step2'),
      dialog: {
        headline: t('onboarding_trial_diablog_title_step2'),
        description: '',
        actionConfirm: t('common_update'),
        actionCancel: t('common_cancel'),
        fieldName: t('onboarding_trial_input_brand_name'),
        fieldUrl: t('onboarding_trial_input_brand_url'),
      },
    },
    [STEP.COMPETITORS]: {
      subTitle: t('onboarding_trial_title_step3'),
      loader: {
        headline: t('onboarding_trial_loading_step3'),
        note1: t('onboarding_trial_loading_step3_note1'),
        note2: t('onboarding_trial_loading_step3_note2'),
      },
      disclaimer: '',
      dialog: {
        headline: t('onboarding_trial_diablog_title_step3'),
        description: '',
        actionConfirm: t('common_add'),
        actionCancel: t('common_cancel'),
        fieldName: t('onboarding_trial_input_brand_name_competitor'),
        fieldUrl: t('onboarding_trial_input_brand_url_competitor'),
      },
    },
    [STEP.COMPLETE]: {
      loader: {
        headline: t('onboarding_trial_loading_step_complete'),
        note1: t('onboarding_trial_loading_step_complete_note1'),
        note2: t('onboarding_trial_loading_step_complete_note2'),
      },
    },
  };
};
